import AsyncStorage from "@react-native-async-storage/async-storage";
import { useNavigation } from "@react-navigation/native";
import { Fragment, useEffect, useState } from "react";
import {
  ActivityIndicator,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { useTranslation } from "react-i18next";
import { AppBar, SurveyDetailCard } from "../components";
import PopupFactory, { usePopup } from "../components/PopupFactory";
import { checkCode, getLogs, submitScreening } from "../services/screening";
import {
  calculate,
  checkEligibility,
  getDetailSurvey,
  submitSurvey,
} from "../services/survey";
import md5 from "md5";
import { getNumber } from "../services/number";
import i18n from "../translation/index";

const SurveyDetailPage = ({ route }) => {
  const { params } = route;
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [answer, setAnswer] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [memberId, setMemberId] = useState(undefined);
  const [refId, setRefId] = useState(undefined);
  const [totalQuestion, setTotalQuestion] = useState(0);
  const [listChosenAll, setListChosenAll] = useState([]);
  let totalSection = 0;
  let doesSectionExists = false;
  let sectionObject = {};
  let sectionNumbers = 0;
  // const [sectionNumbers, setSectionNumbers] = useState(0);
  const navigation = useNavigation();
  let questionNumber = 0;
  const { toggle, visible } = usePopup();
  const [popupType, setPopupType] = useState("incomplete-survey");

  useEffect(() => {
    async function getMember() {
      const memberId = await AsyncStorage.getItem("token");
      setMemberId(memberId);

      const theRefId = await AsyncStorage.getItem("refId");
      setRefId(theRefId);

      return memberId;
    }

    getMember();
  }, [params]);

  useEffect(() => {
    if (!memberId || !refId || data?.length === 0) {
      return;
    }

    async function getLogData() {
      const result = await getLogs({
        quizId: params?.quizId,
        refId: refId,
        memberId: memberId,
      });

      if (result.status === 200) {
        const logData = result.data?.data;
        const mappedData = {};
        logData?.map((d) => {
          mappedData[d.detail_id] = d.answers;
          data?.map((a) => {
          if (a.rowId === d.detail_id) {
            mappedData[`no-${a.orderNo}`] = d.answers;
          }
        })
        });
        setAnswer(mappedData);
      }
    };
    
    getLogData();

  }, [params, memberId, refId, data]);

  useEffect(() => {
    getDetailSurvey(params?.quizId)
      .then((res) => {
        setData(res.data);
        setTotalQuestion(
          res.data.filter(
            (i) => i.quizType !== "sub_question" && i.quizType !== "section"
          ).length
        );
      })
      .finally(() => setIsLoading(false));
  }, [params]);

  useEffect(() => {
    const tempListChosenAll = [...listChosenAll]; // used to save all of number with Select all
    const newAnswer = {};
    data.sort((a, b) => a.orderNo - b.orderNo).map((item) => {
      const filteredFrom = JSON.parse(item.detail)?.filter_from;
      if (item.quizType == "data_source_multiple_no_option") {
        // if there is filterFrom has been Select all, then make the rest as no options
        if (tempListChosenAll.indexOf(parseInt(filteredFrom)) > -1) { 
          const noOptionPlaceholder = JSON.parse(item.detail)?.no_option;
          if (!answer[item.rowId]) {
            newAnswer[item.rowId] = noOptionPlaceholder;
          }
          tempListChosenAll.push(parseInt(item.orderNo));
        } else {
          if (answer[item.rowId]) {
            newAnswer[item.rowId] = "";
          }
        }
      }
    });

    setAnswer({...answer, ...newAnswer});
  }, [listChosenAll.join(",")]);

  useEffect(() => {
    async function getLang() {
      return await AsyncStorage.getItem("lang");
    }

    getLang().then((res) => {
      if (!res) {
        AsyncStorage.setItem("lang", "id");
        i18n.changeLanguage("id");
        return;
      }
      AsyncStorage.setItem("lang", res);
      i18n.changeLanguage(res);
    });
  }, []);

  return (
    <>
      <AppBar
        title={params?.isScreening === "0" ? "Survey" : "Forms"}
        isBack
        jump={
          params?.fromAgenda === 1
            ? "AgendaProgram"
            : params?.back
            ? params?.back
            : "Survey"
        }
        params={{
          additionalContentId: params?.additionalContentId,
          isScreening: params?.isScreening,
          refresh: new Date().getTime(),
          memberId: memberId,
          isQuick: params?.isQuick,
        }}
      />
      {isLoading ? (
        <View style={styles.loading}>
          <ActivityIndicator color="#6724E2" />
        </View>
      ) : (
        <Fragment>
          <View style={styles.list}>
            <ScrollView contentContainerStyle={{ gap: 16, padding: 16 }}>
              {data
                .sort((a, b) => a.orderNo - b.orderNo)
                .map((item) => {
                  if (
                    (item.parentId === "" || !item.parentId) &&
                    item.quizType !== "section"
                  ) {
                    questionNumber += 1;
                  }
                  if (item.quizType == "section") {
                    doesSectionExists = true;
                    totalSection += 1;
                    sectionObject[getNumber(totalSection - 1)] = [];
                  }

                  if (doesSectionExists === true) {
                    if (
                      (item.parentId === "" || !item.parentId) &&
                      item.quizType !== "section"
                    ) {
                      const totalData =
                        sectionObject[getNumber(totalSection - 1)].length + 1;
                      sectionObject[getNumber(totalSection - 1)].push(
                        totalData
                      );
                      sectionNumbers = totalData;
                    }
                  }

                  return (
                    <SurveyDetailCard
                      key={item.rowId}
                      doesSectionExists={doesSectionExists}
                      questionNumber={questionNumber}
                      data={item}
                      sectionNumbers={sectionNumbers}
                      section={getNumber(totalSection - 1)}
                      answer={answer}
                      handleAnswer={setAnswer}
                      isNewPractice={params.isNewPractice}
                      setListChosenAll={setListChosenAll}
                      listChosenAll={listChosenAll}
                      memberId={memberId}
                      refId={refId}
                      quizId={params?.quizId}
                    />
                  );
                })}
            </ScrollView>
          </View>
          <View style={styles.footer}>
            <View style={styles.bar}>
              <View
                style={[
                  styles.totalBar,
                  {
                    width: `${Math.ceil(
                      (Object.keys(answer).filter((i) => i.indexOf("no-") != 0)
                        .length /
                        totalQuestion) *
                        100
                    )}%`,
                  },
                ]}
              />
            </View>
            <View style={styles.footerContent}>
              <View>
                <Text style={styles.statusTx}>
                  {t("survey:label-question")}
                </Text>
                <Text
                  style={[
                    styles.statusTx,
                    {
                      marginTop: 4,
                      fontWeight: 600,
                      fontFamily: "Archivo-SemiBold",
                    },
                  ]}
                >
                  {
                    Object.keys(answer).filter((i) => i.indexOf("no-") != 0)
                      .length
                  }{" "}
                  {t("survey:label-from")} {totalQuestion}{" "}
                  {t("survey:label-answered")}
                </Text>
              </View>
              <TouchableOpacity
                style={styles.button}
                onPress={() => {
                  if (
                    totalQuestion >
                    Object.keys(answer).filter((i) => i.indexOf("no-") != 0)
                      .length
                  ) {
                    setPopupType(
                      `incomplete-survey${
                        params?.isNewPractice === 1 ? "" : "-assessment"
                      }`
                    );
                    return toggle();
                  }
                  const formatedAnswer = Object.keys(answer)
                    .filter((i) => i.indexOf("no-") != 0)
                    .map((i) => {
                      let answered = answer[i];
                      if (Array.isArray(answer[i])) {
                        answered = answer[i].join(":::");
                      }
                      return {
                        id: i,
                        answered: answered,
                      };
                    });

                  setIsLoading(true);

                  if (params?.respId && params?.respId !== "") {
                    return submitScreening(
                      params?.quizId,
                      params?.additionalContentId,
                      params?.respId,
                      formatedAnswer
                    ).then(async (res) => {
                      // if (params.isNewPractice === 1) {
                      //   retrn
                      // }

                      await calculate(
                        params?.quizId,
                        memberId + "?respId=" + params?.respId
                      );

                      // checkCode(additionalContentId, quizId)
                      // .then((res) => {
                      //   const isLocked = res.data;
                      //   if (isLocked) {
                      //     return navigation.navigate(
                      //       "LockedScreening",
                      // {
                      //   quizId: params?.quizId,
                      //   additionalContentId: params?.additionalContentId,
                      //   respId: params?.respId
                      // }
                      //     );
                      //   }

                      return navigation.navigate(
                        params?.isScreening === "0"
                          ? "SurveyResult"
                          : "ScreeningResult",
                        {
                          quizId: params?.quizId,
                          additionalContentId: params?.additionalContentId,
                          respId: params?.respId,
                          fromAgenda: params?.fromAgenda,
                          back: params?.back,
                        }
                      );
                      // });

                      // navigation.navigate("ScreeningResult", {
                      //   quizId: params?.quizId,
                      //   additionalContentId: params?.additionalContentId,
                      //   respId: params?.respId
                      // });
                    });
                  }

                  checkEligibility(
                    params?.quizId,
                    memberId,
                    params?.additionalContentId
                  ).then((res) => {
                    const resp = res?.data;
                    if (resp || params?.isNewPractice === 1) {
                      return submitSurvey(
                        params?.quizId,
                        memberId,
                        formatedAnswer,
                        params?.additionalContentId +
                          (refId && refId !== null ? `?ref_id=${refId}` : ``)
                      ).then(async (res) => {
                        if (params?.isNewPractice === 1) {
                          setPopupType("new-practice");
                          setIsLoading(false);
                          setAnswer({});
                          toggle();
                          return;
                        } else {
                          setPopupType("success-assessment");
                          setIsLoading(false);
                          setAnswer({});
                          toggle();
                        }

                        await calculate(
                          params?.quizId,
                          memberId +
                            (refId && refId !== null ? "?refId=" + refId : "")
                        );

                        // navigation.navigate(params?.isScreening === "0" ? "SurveyResult" : "ScreeningResult", {
                        //   quizId: params?.quizId,
                        //   additionalContentId: params?.additionalContentId,
                        //   isScreening : params?.isScreening
                        // });

                        if (
                          refId &&
                          (!params?.isNewPractice ||
                            (params?.isNewPractice &&
                              params?.isNewPractice === 0))
                        ) {
                          const newRefId = md5(new Date().getTime());
                          AsyncStorage.setItem("refId", newRefId);
                          const answeredList = await AsyncStorage.getItem(
                            "answerId"
                          );
                          if (
                            answeredList?.indexOf(
                              params?.quizId.substring(0, 6)
                            ) < -1 ||
                            !answeredList
                          ) {
                            AsyncStorage.setItem(
                              "answerId",
                              params?.quizId.substring(0, 6) + ","
                            );
                          }
                        }

                        checkCode(
                          params?.additionalContentId,
                          params?.quizId
                        ).then((res) => {
                          const isLocked = res.data;
                          if (isLocked) {
                            return navigation.navigate("LockedScreening", {
                              quizId: params?.quizId,
                              additionalContentId: params?.additionalContentId,
                              respId: params?.respId,
                              fromAgenda: params?.fromAgenda,
                              back: params?.back,
                            });
                          }

                          return navigation.navigate(
                            params?.isScreening === "0"
                              ? "SurveyResult"
                              : "ScreeningResult",
                            {
                              quizId: params?.quizId,
                              additionalContentId: params?.additionalContentId,
                              respId: params?.respId,
                              fromAgenda: params?.fromAgenda,
                              back: params?.back,
                            }
                          );
                        });
                      });
                    } else {
                      setIsLoading(false);
                      setPopupType("not-eligible");
                      toggle();
                    }
                  });
                }}
              >
                <Text style={styles.buttonTx}>
                  {params?.isNewPractice === 1
                    ? `${t("survey:button-save")}`
                    : `${t("survey:button-submit")}`}
                </Text>
              </TouchableOpacity>
            </View>
          </View>
          <PopupFactory
            type={popupType}
            visible={visible}
            onCancel={toggle}
            onSubmit={toggle}
          />
        </Fragment>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  list: {
    height: "100%",
    flex: 1,
    marginTop: 1,
    paddingBottom: 6,
    backgroundColor: "#fff",
  },
  footer: {
    // position: "fixed",
    left: 0,
    bottom: 0,
    width: "100%",
    backgroundColor: "#fff",
  },
  bar: {
    width: "100%",
    height: 4,
    backgroundColor: "#EEEAFF",
  },
  totalBar: {
    height: 4,
    backgroundColor: "#6724E2",
  },
  statusTx: {
    fontFamily: "Archivo-Regular",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: 12,
  },
  footerContent: {
    paddingHorizontal: 16,
    paddingVertical: 12,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  button: {
    borderRadius: 10,
    paddingVertical: 12,
    paddingHorizontal: 40,
    backgroundColor: "#6724E2",
  },
  buttonTx: {
    fontFamily: "Archivo-Bold",
    fontWeight: 700,
    color: "#fff",
    fontSize: 12,
  },
  loading: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#EEEAFF",
  },
});

export default SurveyDetailPage;
